import { render, staticRenderFns } from "./course_info.vue?vue&type=template&id=c620688a&scoped=true&"
import script from "./course_info.vue?vue&type=script&lang=js&"
export * from "./course_info.vue?vue&type=script&lang=js&"
import style0 from "./course_info.vue?vue&type=style&index=0&id=c620688a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c620688a",
  null
  
)

export default component.exports